import React from 'react';
import type { CheckboxProps } from './Checkbox.props';
import IcCheckBoxSelected from './assets/IcCheckboxSelected.svg';
import IcCheckBox from './assets/IcCheckBox.svg';
import Text from '../Text';

import styled from 'styled-components';

const Checkbox = ({ value, onChange, label, size = 24, disabled, style, className }: CheckboxProps) => {

  const handleToggle = () => {
    if (!disabled) {
      onChange?.(!value);
    }
  };

  return (
    <Container onClick={handleToggle} style={style} className={className} type='button'>
      <WrapperIcon  disabled={disabled}>
        {value ? <img src={IcCheckBoxSelected} width={size} height={size} alt='checked' /> : <img src={IcCheckBox} width={size} height={size} alt='unchecked' />}
      </WrapperIcon>

      {label && (
        <Text variant='BODY_1' className='styled-text' color={disabled ? 'fill_2' : 'text_1'}>
          {label}
        </Text>
      )}
    </Container>
  );
};

export default Checkbox;

const WrapperIcon = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ${({ disabled }) => disabled && `
    cursor: not-allowed;
    opacity: 0.6;
  `}
`;

const Container = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
  background: transparent;
  padding: 0;
`;
